import {
    request,
} from '../request.js'

// 文档列表
export function reqPageList(data) {
    return request({
        url: '/web/back/sys/navigation/pageList49',
        method: 'POST',
        data
    })
}

// 新增  
export function reqSave(data) {
    return request({
        url: '/web/back/sys/navigation/save',
        method: 'POST',
        data
    })
}

// 修改  /web/back/sys/navigation/update
export function reqUpdate(data) {
    return request({
        url: '/web/back/sys/navigation/update',
        method: 'POST',
        data
    })
}
// 删除  /web/back/sys/navigation/delete?id=""
export function reqDelete(id) {
    return request({
        url: '/web/back/sys/navigation/delete',
        method: 'delete',
        params: {
            id
        }
    })
}